import { render, staticRenderFns } from "./CreateApplication.vue?vue&type=template&id=5867f5e9"
import script from "./CreateApplication.vue?vue&type=script&lang=js"
export * from "./CreateApplication.vue?vue&type=script&lang=js"
import style0 from "./CreateApplication.vue?vue&type=style&index=0&id=5867f5e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports